export const trimSwedishTrainNumber = (trainNumber: string): string =>
  trainNumber.replace(/-+/g, "-").trim();
